import { Col, Divider, Flex, Input, Row, Skeleton, Typography } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";
import Page from "~Common/Page";
import UserPermissionsDataTable from "~pages/Users/components/UserPermissionsDataTable/UserPermissionsDataTable.tsx";
import useGetCurrentUserDetails from "./hooks/useGetCurrentUserDetails.ts";

const CurrentUserDetailsPage = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const { data: userDetails, isLoading, refetch } = useGetCurrentUserDetails();

  const goBackToUserList = () => navigate(location?.state?.from || -1, { replace: true });

  return (
    <Page title={<FormattedMessage id="userDetailsPage.title" />} onBack={goBackToUserList}>
      <Flex justify="space-between" vertical={true} gap={8}>
        <Typography.Title level={4}>{formatMessage({ id: "basic.details" })}</Typography.Title>
        <Row>
          <Col span={8}>
            <Typography.Text>{formatMessage({ id: "permissions.user.name" })}</Typography.Text>
            {isLoading ? <Skeleton.Input block active size="large" /> : <Input size="large" disabled value={userDetails?.name} />}
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <Typography.Text>{formatMessage({ id: "email" })}</Typography.Text>
            {isLoading ? <Skeleton.Input block active size="large" /> : <Input size="large" disabled value={userDetails?.email} />}
          </Col>
        </Row>
        <Divider />
        <Typography.Title level={5}>{formatMessage({ id: "permissions.user.roles.assigned" })}</Typography.Title>
        <UserPermissionsDataTable
          permissions={userDetails?.permissions}
          permissionScopeResources={userDetails?.resources || {}}
          isLoading={isLoading}
          readOnly={true}
          onRefresh={refetch}
          localStorageUniqueId={"currentUserDetailsPage"}
        />
      </Flex>
    </Page>
  );
};

export default CurrentUserDetailsPage;
